import { Box } from "../../box";
import { forwardRef, useMemo } from "react";
import { Keys, cssModule, mergeProps, useEventCallback, useSlots } from "../../shared";
import { Text } from "../../typography";
import { useTabsContext } from "./TabsContext";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const TabKeyProp = "data-o-ui-key";
const DefaultElement = "button";
export function InnerTab({
  active,
  as = DefaultElement,
  children,
  disabled,
  focus,
  forwardedRef,
  hover,
  tab: {
    key,
    panelId,
    tabId
  },
  ...rest
}) {
  const {
    isManual,
    onSelect,
    selectedKey
  } = useTabsContext();
  const {
    icon,
    lozenge,
    text
  } = useSlots(children, useMemo(() => ({
    _: {
      defaultWrapper: Text
    },
    icon: {
      className: "o-ui-tab-icon",
      size: "sm"
    },
    lozenge: {
      className: "o-ui-tab-lozenge",
      color: "primary",
      size: "sm"
    },
    text: {
      className: "o-ui-tab-text"
    }
  }), []));
  const handleClick = useEventCallback(event => {
    event.preventDefault();
    onSelect(event, key);
  });
  const handleKeyDown = useEventCallback(event => {
    switch (event.key) {
      case Keys.enter:
      case Keys.space:
        event.preventDefault();
        onSelect(event, key);
        break;
    }
  }); // Hotfix for https://bugzilla.mozilla.org/show_bug.cgi?id=1487102

  const handleKeyUp = useEventCallback(event => {
    if (event.key === Keys.space) {
      event.preventDefault();
    }
  });
  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      [TabKeyProp]: key,
      "aria-controls": panelId,
      "aria-selected": key === selectedKey,
      as,
      className: cssModule("o-ui-tab", icon && "has-icon", active && "active", focus && "focus", hover && "hover"),
      disabled,
      id: tabId,
      onClick: handleClick,
      onKeyDown: isManual ? handleKeyDown : undefined,
      onKeyUp: isManual ? handleKeyUp : undefined,
      ref: forwardedRef,
      role: "tab"
    }),
    children: [icon, text, lozenge]
  });
}
InnerTab.defaultElement = DefaultElement;
export const Tab = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerTab, { ...props,
  forwardedRef: ref
}));